export const polarToCartesian = (
  cx: number,
  cy: number,
  radius: number,
  angleDeg: number
): { x: number; y: number } => {
  const rad = (angleDeg * Math.PI) / 180;

  return { x: cx + radius * Math.cos(rad), y: cy - radius * Math.sin(rad) };
};

export const convertPolToCar = <T extends number>(
  cx: T,
  cy: T,
  r: T,
  angle: T
): { x: number; y: number } => ({
  x: cx + r * Math.cos(angle * (Math.PI / 180)),
  y: cy + r * Math.sin(angle * (Math.PI / 180)),
});
